import { useMutation, useQueryClient } from 'react-query'
import request from '../../../request'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { omit } from 'ramda'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useEditAudience = () => {
  const dealership = useDealership()
  const queryClient = useQueryClient()
  return useMutation(
    ({ data }: any) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/audiences/${data._id}`,
        method: 'PATCH',
        data: omit(['_id'], data),
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['dealership', dealership?.id, 'audiences'])
      },
    },
  )
}
